export const TRANSLATION_KEYS = {
    Heading: "settingPage.attributePage.formDrawer.heading",
    AttributeLabel: "settingPage.attributePage.formDrawer.attributeLabel",
    AttributePlaceholder: "settingPage.attributePage.formDrawer.attributePlaceholder",
    AttributeErrorMessage: "settingPage.attributePage.formDrawer.attributeErrorMessage",
    AttributeTypeLabel: "settingPage.attributePage.formDrawer.attributeTypeLabel",
    AttributeTypePlaceholder: "settingPage.attributePage.formDrawer.attributeTypePlaceholder",
    AttributeTypeErrorMessage: "settingPage.attributePage.formDrawer.attributeTypeErrorMessage",
    AreaLabel: "ticketDetailsPage.detailsForm.areaLabel",
    AreaPlaceholder: "ticketDetailsPage.detailsForm.areaPlaceholder",
    TopicLabel: "ticketDetailsPage.detailsForm.departmentLabel",
    TopicPlaceholder: "ticketDetailsPage.detailsForm.departmentPlaceholder",
    TopicErrorMessage: "ticketDetailsPage.detailsForm.departmentErrorMessage",
    OptionLabel: "settingPage.attributePage.formDrawer.optionLabel",
    OptionPlaceholder: "settingPage.attributePage.formDrawer.optionPlaceholder",
    OptionDescription: "settingPage.attributePage.formDrawer.optionDescription",
    OptionErrorMessage: "settingPage.attributePage.formDrawer.optionErrorMessage",
    SaveButtonText: "common.saveText",
    CancelButtonLabel: "common.dismissText",
    RenderAttribute: "settingPage.attributePage.formDrawer.renderAttributeLabel"
} as const;